import { useFormContext } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
const switchContainerCss = "s1qhcngj";
const SwitchContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(switchContainerCss, props.className)} />;
});
const GuestsAllowedLocked = () => {
  const {
    values: {
      guestsAllowed
    }
  } = useFormContext();
  return guestsAllowed ? I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.guests_permitted') : I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.guests_forbidden');
};
const GuestsAllowedField = ({
  disabled
}) => {
  const {
    values: {
      guestsAllowed
    },
    setFieldValue,
    setFieldTouched
  } = useFormContext();
  const handleChange = useCallback(() => {
    setFieldValue('guestsAllowed', !guestsAllowed);
    setFieldTouched('guestsAllowed');
  }, [guestsAllowed, setFieldTouched, setFieldValue]);
  return <SwitchContainer>
      <BodyText color="muted" size="medium">
        {I18n.t('publisher.event_type_editor.sections.booking_page_options.invitee_questions.allow_invitees_to_add_guests')}
      </BodyText>
      <SwitchInput checked={guestsAllowed} onChange={handleChange} name="guestsAllowed" disabled={disabled} />
    </SwitchContainer>;
};
export const GuestsAllowedSwitch = ({
  isLocked,
  ...props
}) => !isLocked ? <GuestsAllowedField {...props} /> : <GuestsAllowedLocked {...props} />;

require("./guests_allowed_switch.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./guests_allowed_switch.js");